import React, {useState, useEffect, useCallback} from 'react';
import Sample from 'repos/Sample.js';
import AudioUnit from 'engine/audio.js';
import Colors from 'components/Colors.js';
const colors = new Colors();

export default ({work, userName, loadSample}) => {
    const [sampleHovered, setSampleHovered] = useState(undefined);
    const [sampleText, setSampleText] = useState(undefined);

    useEffect(() => {
        if (sampleHovered) {
            setSampleText(sampleHovered.title);
        } else {
            setSampleText(undefined);
        }
    }, [sampleHovered, setSampleText]);

    let {samples, tags} = work;
    return (
        <div className="work samples">
          <div className="samples-container">
            {samples.map(
                sample =>
                    <WorkSample
                      loadSample={() => loadSample(sample.ipfsHash)}
                      onMouseOver={() => setSampleHovered(sample)}
                      onMouseLeave={() => setSampleHovered(undefined)}
                      sample={sample}/>)}
          </div>
          <div className="name">
            <div className="work-author">
              {sampleText ? sampleText : userName}
            </div>
            <div className="sampled">
              {tags.map(tag => <span className="tag">{tag}</span>)}
            </div>
          </div>
        </div>
    );
};

const WorkSample = ({sample, onMouseOver, onMouseLeave, loadSample}) => {
    if (sample.videoId) {
        var url = 'https://img.youtube.com/vi/' + sample.videoId + '/1.jpg';
        return (
            <img
              onMouseDown={loadSample}
              onMouseOver={onMouseOver}
              onMouseLeave={onMouseLeave}
              src={url} className="work-sample"/>
        );
    }
    let color = colors.saturate(colors.getColorForHash(sample.ipfsHash), 3);
    let style = {
        backgroundColor: color
    };
    return (
        <div
          onMouseDown={loadSample}
          onMouseOver={onMouseOver}
          onMouseLeave={onMouseLeave}
          className="work-sample" style={style}/>
    );
};
